<template>
    <div class="register_box">
        <el-tabs type="border-card" stretch>
            <!-- 公司用户 -->
            <el-tab-pane lazy>
                <!-- 标题 -->
                <template #label>
                    <div class="register_tab_label">
                        <img :src="require('@/assets/img/register/company.png')" alt="">
                        <span>{{$t("message.register.tabs1")}}</span>
                    </div>
                </template>
                <!-- 主体内容 -->
                <div class="register_tab_body">
                    <register-company></register-company>
                </div>
            </el-tab-pane>
            <!-- 个人用户 -->
            <el-tab-pane lazy>
                <!-- 标题 -->
                <template #label>
                    <div class="register_tab_label">
                        <img :src="require('@/assets/img/register/personal.png')" alt="">
                        <span>{{$t("message.register.tabs2")}}</span>
                    </div>
                </template>
                <!-- 主体内容 -->
                <div class="register_tab_body">
                    <register-personal></register-personal>
                </div>
            </el-tab-pane>
        </el-tabs>
        <user-agreement></user-agreement>
    </div>
</template>

<script>
export default {
    components: {
        registerCompany: () => import("@/components/registerCompany"),
        registerPersonal: () => import("@/components/registerPersonal"),
        userAgreement: () => import("@/components/agreement")
    }
}
</script>

<style scoped>
/* 组件盒子 */
.register_box{
    width: 680px;
    margin: 60px auto;
}
/* 
*******************
*/
/* 标签页高度 */
.register_box>>>.el-tabs__item{
    height: auto;
    line-height: normal
}
/* 标签页标题 */
.register_tab_label{
    height: 50px;
    line-height: 50px;
}
.register_tab_label>img{
    width: 40px;
    height: 40px;
}
.register_tab_label>span{
    margin-left: 10px;
    font-size: 15px;
    font-weight: bold;
}
/* 
*******************
*/
/* 内容主体盒子 */
.register_tab_body{
    padding: 20px 60px;
    padding-right: 120px;
}
</style>
